import { Component } from '@angular/core';
import { CoreService } from '../../../../../shared/src/lib/services/core.service';
import type { AppSettings } from '../../app.config';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-blank',
    templateUrl: './blank.component.html',
    styleUrls: [],
    imports: [RouterOutlet, MaterialModule, NgClass]
})
export class BlankComponent {
  private readonly htmlElement!: HTMLHtmlElement;

  options = this.settings.getOptions();

  constructor(private readonly settings: CoreService) {
    this.htmlElement = document.querySelector('html')!;
    // Initialize project theme with options
    this.receiveOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }
}
